import Alert from '@material-ui/lab/Alert';

export default Alert;
